import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=3b946300&scoped=true"
import script from "./BranchList.vue?vue&type=script&lang=js"
export * from "./BranchList.vue?vue&type=script&lang=js"
import style0 from "./BranchList.vue?vue&type=style&index=0&id=3b946300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b946300",
  null
  
)

export default component.exports